import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useCustomerQuery } from '../../../api/customers';
import { useBoolean } from 'usehooks-ts';
import { UpdatePasswordForm } from './UpdatePasswordForm';
import { UpdatedView } from './UpdatedView';
import { BrightyStepButton, Grid, Step, Stepper } from '@razz-team/ui-web';
import { useEffect, useState } from 'react';
import { UpdatePhoneForm } from './UpdatePhoneForm';
import { UpdateEmailForm } from './UpdateEmailForm';

enum SecondFactorStep {
  unknown = -1,
  email,
  phone,
  password,
}

export function SecondFactorPage() {
  const { t } = useTranslation();
  const customerQuery = useCustomerQuery();
  const identity = customerQuery.data?.identity;
  const doneFlag = useBoolean(false);
  const [step, setStep] = useState(SecondFactorStep.unknown);

  useEffect(() => {
    if (!identity?.email) {
      setStep(SecondFactorStep.email);
    } else if (!identity?.phone) {
      setStep(SecondFactorStep.phone);
    } else if (!identity?.hasPassword) {
      setStep(SecondFactorStep.password);
    } else {
      doneFlag.setTrue();
    }
  }, [identity, doneFlag]);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Secure account')}
          parent={{
            to: '/account/settings',
            title: t('Settings'),
          }}
        />
      }
      compact
    >
      <Grid size={12}>
        <Stepper activeStep={step} sx={{ width: '100%' }} alternativeLabel>
          <Step>
            <BrightyStepButton>{t('Email')}</BrightyStepButton>
          </Step>
          <Step>
            <BrightyStepButton>{t('Phone')}</BrightyStepButton>
          </Step>
          <Step>
            <BrightyStepButton>{t('Password')}</BrightyStepButton>
          </Step>
        </Stepper>
      </Grid>
      {identity ? (
        doneFlag.value ? (
          <UpdatedView text={t('Your account is fully secure!')} />
        ) : step === SecondFactorStep.email ? (
          <UpdateEmailForm identity={identity} />
        ) : step === SecondFactorStep.phone ? (
          <UpdatePhoneForm identity={identity} />
        ) : step === SecondFactorStep.password ? (
          <UpdatePasswordForm identity={identity} />
        ) : null
      ) : null}
    </MainLayout>
  );
}
